import React, { useState } from 'react';
import SelectField from '../SelectField';
import Error from '../../Error/Error';
import { request } from '../../../interfaces/networkManager';
import { CircularProgress } from '@mui/material';
import { User } from '../../../models/user';

interface UserPickerProps {
	name: string,
	placeholder: string,
	label: string,
	title: string,
	value: User,
	onChange: (value: User) => void,
	url: string,
}

const UserPicker = ({name, placeholder, label, title, value, onChange, url, ...rest } : UserPickerProps) => {
	const [error, setError] = useState<string | null>(null);
	const [options, setOptions] = useState<User[]>();

	// Assurez-vous que la valeur est toujours valide
	const safeValue = value || { value: '', label: '' };

	React.useEffect(() => {
		request<User[]>(url)
			.then((response: User[]) => {
				if (!response.length) return setError('Erreur lors de la récupération des utilisateurs');
				setOptions(response);
			})
	}, [url]);

	return error ? (
		<Error message={error} />
	) : options == null ? (
		<CircularProgress />
	) : (
		<SelectField 
			{...rest} 
			name={name} 
			placeholder={placeholder} 
			label={label} 
			title={title} 
			options={options} 
			onChange={onChange} 
			value={safeValue} 
			functionValidator={() => ({ result: true, message: '' })} 
		/>
	);
};

export default UserPicker;
